html,
body {
    margin: 0;
    padding: 0;
    background: linear-gradient(135deg, #ede9fb 0%, #e3f7ff 100%);
    background-attachment: fixed;
    background-size: cover;
    min-height: 100%; /* allows background to grow with content */
}

body {
    display: flex;
    flex-direction: column;
}

.container {
    font-family: monospace;
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    background: transparent;
    flex: 1 0 auto; /* grow only when needed */
}

.chatRoot {
    flex: 1;
    display: flex;
}

.chatContainer {
    font-family: monospace;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
}

.chatEmptyState {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    max-height: 1024px;
    gap: 20px;
    transform: scale(0.9);
    transform-origin: top center;
}

/* When there IS a powerplant image */
.chatEmptyState.hasImage {
    justify-content: flex-start;
    padding-top: 0px; /* space below navbar */
}

/* When there is NO image */
.chatEmptyState.noImage {
    justify-content: center; /* center content vertically */
    padding-top: 200px;
}

.chatEmptyStateTitle {
    font-size: 4rem;
    font-weight: 600;
    margin-top: 0;
    margin-bottom: 0px;
}

.chatEmptyStateSubtitle {
    font-weight: 600;
    margin-bottom: 10px;
}

/* Keep consistent spacing between image and navbar */
.powerplantImageContainer {
    width: 900px;
    height: 300px;
    position: relative;
    margin-top: 0px; /* 👈 ensures image never overlaps navbar */
    margin-bottom: 0px;
    flex-shrink: 0;
}

.powerplantImageContainer img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    display: block;
}

.powerplantImageSkeleton {
    width: 100%;
    height: 100%;
    background-color: #f0f0f0;
    border-radius: 12px;
    animation: pulse 1.5s ease-in-out infinite;
}

@media only screen and (max-height: 780px), only screen and (max-width: 1024px) {
    .chatEmptyState {
        padding-top: 0px; /* reduce on small screens */
    }

    .powerplantImageContainer {
        width: 700px;
        height: 233px;
        margin-top: 0px; /* smaller spacing for compact layouts */
        margin-bottom: 0px;
    }
}

.chatMessageStream {
    font-family: monospace;
    flex-grow: 1;
    max-height: 1024px;
    max-width: 1028px;
    width: 100%;
    overflow-y: auto;
    padding-left: 24px;
    padding-right: 24px;
    display: flex;
    flex-direction: column;
}

.chatMessageGpt {
    font-family: monospace;
    margin-bottom: 20px;
    max-width: 80%;
    display: flex;
    min-width: 0;
    overflow-x: hidden;
}

.chatMessageGptMinWidth {
    font-family: monospace;
    max-width: 500px;
    margin-bottom: 20px;
}

.reasoningContainer {
    margin: 0;
    padding: 6px 12px;
    width: 100%;
    box-sizing: border-box;
    background: rgb(249, 249, 249);
    border-radius: 8px;
    box-shadow:
        0 0 2px rgba(0, 0, 0, 0.08),
        0 2px 4px rgba(0, 0, 0, 0.08);
}

.reasoningHeader {
    display: flex;
    align-items: center;
    gap: 6px;
    background: none;
    border: none;
    cursor: pointer;
    padding: 2px 4px;
    font-size: 12px;
    font-family: inherit;
    color: #8a8a8a;
}

.reasoningHeader:hover {
    color: #666;
}

.reasoningBody {
    border-left: 2px solid #e0e0e0;
    margin-left: 8px;
    padding-left: 10px;
    max-height: 500px;
    overflow-y: auto;
    overflow-x: hidden;
}

.reasoningNode {
    margin: 2px 0;
}

.reasoningNodeHeader {
    display: flex;
    align-items: center;
    gap: 6px;
    background: none;
    border: none;
    cursor: pointer;
    padding: 2px 4px;
    font-size: 12px;
    font-family: inherit;
    color: #999;
    font-style: italic;
}

.reasoningNodeHeader:hover {
    color: #777;
}

.reasoningText {
    color: #9a9a9a;
    font-size: 12px;
    font-style: italic;
    padding: 2px 4px 6px 22px;
    white-space: pre-wrap;
    line-height: 1.4;
    overflow-wrap: break-word;
    word-break: break-word;
    max-width: 100%;
}

.chatInput {
    position: sticky;
    bottom: 0;
    flex: 0 0 100px;
    padding: 12px 24px 24px 24px;
    width: 100%;
    max-width: 1028px;
    background: transparent; /* let gradient show */
    backdrop-filter: blur(6px); /* optional for subtle glass effect */
}

.chatAnalysisPanel {
    flex: 1;
    overflow-y: auto;
    max-height: 89vh;
    margin-left: 20px;
    margin-right: 20px;
}

.chatSettingsSeparator {
    display: flex;
    flex-direction: column;
    margin-top: 15px;
}

.loadingLogo {
    font-size: 28px;
}

.commandsContainer {
    display: flex;
    align-self: flex-end;
}

.commandButton {
    margin-right: 20px;
    margin-bottom: 20px;
}

.feedbackButton {
    position: fixed;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    background: #0078d4;
    color: white;
    border: none;
    padding: 0;
    cursor: pointer;
    border-radius: 4px 0 0 4px;
    z-index: 1000;
    box-shadow: -2px 2px 8px rgba(0, 0, 0, 0.2);
    transition: background 0.15s, box-shadow 0.15s;
    width: 30px;
    height: 110px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.feedbackButton:hover {
    background: #106ebe;
    box-shadow: -3px 3px 12px rgba(0, 0, 0, 0.25);
}

.feedbackButtonInner {
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-family: monospace;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 1px;
    text-transform: uppercase;
    transform: rotate(-90deg);
}
